export const enum Router {
    Select = '/',
    GeneratedExamples = '/generated-examples',
}